const url = "https://pradosdelsol.com"
const formUrl = "https://form.pradosdelsol.com/"
const purchaseSuccessUrl = "/purchase-thanks"
const purchaseCancelUrl = "/purchase"
const bookSuccessUrl = "/book-thanks"
const bookCancelUrl = "/book"

export { url, formUrl, purchaseSuccessUrl, purchaseCancelUrl, bookSuccessUrl, bookCancelUrl }